app.controller('DashboardProfileCtrl', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter) {
    $scope.id = $routeParams.id;

    //$scope.clientURL = 'https://eform.sucorsekuritas.com/upload/';
    $scope.clientURL = 'http://localhost:8088/upload/';

    $scope.imgItem = [];

    $scope.modalMessage = {
        CIFNID: 0
    };

    var allPromise = $q.all([
        $http({
            method: 'POST',
            url: '/service/client.svc/retrieveSession',
        }).then(function (data) {
            $scope.userCS = data.data.d;
            if (!data.data.d) {
                $http({
                    method: 'POST',
                    url: '/service/client.svc/SignOut',
                }).then(function (data) {
                    if (data.data.d == true) {
                        $window.location.href = "#/login";
                        $window.location.reload();
                    }
                }, function (error) { })
            }
        }, function (error) { }),


         $http({
             method: 'GET',
             url: '/service/client.svc/getCIFDetail',
         }).then(function (data) {

             if (data.data.d != null) {
                 $scope.CIFInvestor = data.data.d;
                 $scope.imgItem.push({ url: $scope.CIFInvestor.KTPFile, type: 'KTPNPWP', label: 'KTP & NPWP' });
                 $scope.imgItem.push({ url: $scope.CIFInvestor.SelfieFile, type: 'FotoDiri', label: 'Foto Diri bersama KTP' });
                 $scope.imgItem.push({ url: $scope.CIFInvestor.TandaTanganFile, type: 'TandaTangan', label: 'Tanda Tangan Nasabah' });

             }
         }, function (error) { }),

    ]);



    //$scope.openModalRevise = function () {
    //    console.log('revise');
    //    var modalInstance = $uibModal.open({
    //        animation: true,
    //        templateUrl: 'myModalContentRevised.html',
    //        controller: 'ModalInstanceCtrl',
    //        size: 'md',
    //        resolve: {
    //            items: function () {
    //                return $scope.modalMessage;
    //            }
    //        }
    //    });
    //};

    $scope.openModalRejected = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'myModalContentReject.html',
            controller: 'ModalInstanceCtrl',
            size: 'md',
            resolve: {
                items: function () {
                    return $scope.modalMessage;
                }
            }
        });
    };

    allPromise.then(function () {

    });



    $scope.inputCIFID = function () {
        $scope.modalMessage.cifnid = $scope.id;
        $scope.modalMessage.cifid = $scope.CIFIDClientID;
        $scope.modalMessage.name = $scope.CIFInvestorFirstName;
        $scope.modalMessage.dob = $scope.CIFInvestorBirthDate;
        $scope.openModalSubmitCIF();
    }


    $scope.openModalSubmitCIF = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'modalCIF.html',
            controller: 'ModalInputCIF',
            size: 'md',
            backdrop: 'static',
            resolve: {
                items: function () {
                    return $scope.modalMessage;
                }
            }
        });
        modalInstance.result.then(function (resolvedResponse) {
            if (resolvedResponse) {
                if (resolvedResponse.action == 'OK' && resolvedResponse.id) {
                    $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                    $http({
                        method: 'GET',
                        url: '/service/client.svc/checkAvailable?code=' + resolvedResponse.id,
                        cache: false
                    }).then(function (data) {
                        var result = data.data.d;
                        if (result) {
                            $scope.message = '';
                            $http({
                                method: 'GET',
                                url: '/service/client.svc/sendtoBO?CIFNID=' + $scope.id + '&code=' + resolvedResponse.id,
                                cache: false
                            }).then(function (data) {
                                var result = data.data.d;
                                if (result) {
                                    swal('Success', 'Success send to BO', 'success').then(function () {
                                        $window.location.href = "#/CS_Home";
                                    });
                                }
                                else {
                                    swal('Error', 'Gagal', 'error');
                                }

                            }, function (error) { });
                        }
                        else {
                            swal('Error', 'Kode sudah digunakan, harap menggunakan kode lainnya', 'error');
                        }

                    }, function (error) { })
                }
            }
        }, function () { });
    };


});


